const resetData = (setBiology, setBiosed, setHorizontal, setHorsed, setHydrology, setHydrosed, setPermit, setSediment, setSoil, setVertical, setVertsed, setWater) => {
    setBiology({
        type: 'biology',
        title: 'Biology',
        metrics: [
            {
                id: 1,
                metric: 'Vegetation Productivity',
                methods: [
                    {id: 1, method: 'above ground biomass'},
                    {id: 2, method: 'below ground biomass'},
                    {id: 3, method: 'percent cover'},
                    {id: 4, method: 'stem density'},
                    {id: 5, method: 'satellite imagery/remote sensing data'},
                ]
            },
            {
                id: 2,
                metric: 'Habitat',
                methods: [
                    {id: 1, method: 'percent habitat composition'},
                    {id: 2, method: 'percent nuisance species'},
                    {id: 3, method: 'percent high quality habitat'},
                ]
            },
            {
                id: 3,
                metric: 'Focal Species',
                methods: [
                    {id: 1, method: 'presence or absence T&E'},
                    {id: 2, method: 'presence or absence invasive'},
                ]
            },
        ],
        metric: '',
        method: '',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: '',
        // criteriaUnits: '',
        criteriaType: '',
        criteriaJust: '',
        trajectLow: '',
        trajectHigh: '',
        // trajectUnits: '',
        trajectJust: '',
        forecastYears: '',
        forecastJust: '',
        forecastLow: '',
        forecastHigh: '',
        currentConcern: -1,
        futureConcern: -1,
        complete: false,
        attribConcern: false,
    })
    setBiosed({
        type: 'biosed',
        title: 'Decomposition',
        attribute: 'bio',
        metric: 'Decomposition',
        methods: [
            {id: 1, method: 'van post (qual)'},
            {id: 2, method: 'decomp rate (quant)'},
        ],
        method: '',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: "",
        
        criteriaType: '',
        criteriaJust: '',
        currentConcern: -1,
        
        complete: false,
    })
    setHorizontal({
        type: 'horizontal',
        title: 'Horizontal Position',
        metrics: [{id: 1, metric: 'Shoreline Position', methods: [
            {id: 1, method: 'RTK-GPS Survey' },
            {id: 2, method: "Distance from Marker"},
            {id: 3, method: "Aerial Photography"},
            {id: 4, method: 'LiDAR'},
            {id: 5, method: 'Barcode Leveling'},
        ]}],
        metric: 'Shoreline Position',
        method: '',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: '',
        criteriaType: '',
        criteriaJust: '',
        trajectLow: '',
        trajectHigh: '',
        trajectJust: '',
        forecastYears: '',
        forecastJust: '',
        forecastLow: '',
        forecastHigh:'',
        currentConcern: -1,
        futureConcern: -1,
        complete: false,
        attribConcern: false,
    })
    setHorsed({
        type: 'horsed',
        title: 'Horizontal Sediment',
        attribute: 'horizon',
        metric: 'Shoreline Accumulation',
        method: 'MH, sediment grid/plate (below MHW)',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: "",
        criteriaType: '',
        criteriaJust: '',
        currentConcern: -1,
        complete: false,
    })
    setHydrology({
        type: 'hydrology',
        title: 'Hydrology',
        description: 'Description of how water moves in relation to various features of a site.',
        metrics: [
            {
                id: 1,
                metric: 'Hydrological Manipulation',
                methods: [
                    {id: 1, method: 'Percent Area with Restricted or Manipulated Water Flow'},
                    {id: 2, method: 'Restriction Extent (% of tidal range)'},
                    {id: 3, method: 'Percent Time Flooded'},
                ]
            },
            {
                id: 2,
                metric: 'Drainage',
                methods: [
                    {id: 1, method: 'Drainage Capacity/Density'},
                    {id: 2, method: 'Percent Open Water within Marsh (salt pans, pools, or ditches)'},
                    {id: 3, method: 'Percent Time Flooded'},
                ]
            },
        ],
        metric: '',
        method: '',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: '',
        
        criteriaType: '',
        criteriaJust: '',
        trajectLow: '',
        trajectHigh: '',
        
        trajectJust: '',
        forecastYears: '',
        forecastJust: '',
        forecastLow: '',
        forecastHigh:'',
        currentConcern: -1,
        futureConcern: -1,
        attribConcern: false,
        complete: false,
    })
    setHydrosed({
        type: 'hydrosed',
        title: 'Sediment Availability',
        attribute: 'hydro',
        metric: 'Suspended Sediment',
        method: 'TSS, SSC',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: "",
        criteriaType: '',
        criteriaJust: '',
        currentConcern: -1,
        complete: false,
    })
    setPermit({
        type: "permit",
        title: "Permit Alignment",
        permits: [
          {
            id: 1,
            selected: false,
            type: "NJDEP",
            permit:
              "GP #24 Habitat Creation, Restoration, Enhancement and Living Shoreline Activities",
            permitLink: "https://www.nj.gov/dep/rules/rules/njac7_7.pdf",
            requirements: [
              {
                id: 1,
                requirement: "AOI is below MHW ",
                attributeNexus: "Vertical Position",
                metricAlignment: "Elevation",
                questionNeed:
                  "Is the elevation appropriate for restoration targets? ",
                info: "https://tidesandcurrents.noaa.gov/stations.html?type=Water+Levels",
                evaluated: false,
              },
              {
                id: 2,
                requirement: "AOI <= 1 acre",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Overview Map",
                info: "ArcGIS, Google earth",
                evaluated: false,
              },
              {
                id: 3,
                requirement: "Tidelands 1977 ",
                attributeNexus: "Horizontal Position",
                metricAlignment: "Lateral Shoreline Change",
                questionNeed: "Is there space for restoration activities??",
                info: "https://img.nj.gov/imagerywms/BlackWhite1977",
                evaluated: false,
              },
              {
                id: 4,
                requirement: "Special Area Consideration",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed:
                  "Does the project change the community composition and in what way?",
                info: "",
                evaluated: false,
              },
              {
                id: 5,
                requirement: "Special Area Consideration",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Land use considerations",
                info: "",
                evaluated: false,
              },
              {
                id: 6,
                requirement: "Sponsorship",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Are there stakeholder conflicts of interest?",
                info: "NJDEP DFWS, USDA NRCS, WHIP, NJDEP ONRD, NOAA RC",
                evaluated: false,
              },
            ],
          },
          {
            id: 2,
            selected: false,
            type: "NJDEP",
            permit:
              "Creation, Restoration or Enhancement for a Coastal Wetland Mitigation Proposal",
            permitLink: "",
            requirements: [
              {
                id: 1,
                requirement: "Mitigation project goals",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "What is the goal of the proposed project?",
                info: "",
                evaluated: false,
              },
              {
                id: 2,
                requirement:
                  "Why the mitigation location is appropriate for project goals",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed:
                  "Why the mitigation location is appropriate for proposed project goals?",
                info: "",
                evaluated: false,
              },
              {
                id: 3,
                requirement: " USGS quad map(s) ",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "What is the exact location of the proposed project?",
                info: "https://www.nj.gov/state/planning/spc-research-resources-quad.html",
                evaluated: false,
              },
              {
                id: 4,
                requirement:
                  "Location map including all relevant biological and physical features",
                attributeNexus:
                  "Horizontal Position,Vertical Position,Biologic Community",
                metricAlignment:
                  "Lateral Shoreline Change, Elevation, Percent Habitat Composition",
                questionNeed: "Quantified description of flora, fauna, and features",
                info: "https://www.nj.gov/dep/gis/geowebsplash.htm",
                evaluated: false,
              },
              {
                id: 5,
                requirement:
                  "Wetlands being destroyed or disturbed by the permitted activity ",
                attributeNexus: "Biological Community, Output Reflection",
                metricAlignment:
                  "Percent Habitat Composition, Percent Habitat of Quality, Regulatory Consideration 1",
                questionNeed:
                  "What is the total area and type of wetlands being affected that requires mitigation?",
                info: "https://websoilsurvey.sc.egov.usda.gov/app/",
                info2: "https://www.fws.gov/wetlands/",
                evaluated: false,
              },
              {
                id: 6,
                requirement:
                  "Photos showing topographic, vegetative, tidal streams, and wetland features",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Visual descriptive of all flora, fauna, and features",
                info: "",
                evaluated: false,
              },
              {
                id: 7,
                requirement: "Name/address of current owners",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Who is the land owner?",
                info: "",
                evaluated: false,
              },
              {
                id: 8,
                requirement: "Block, lot, municipality, and county boundaries",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "What are the lot boundaries?",
                info: "",
                evaluated: false,
              },
              {
                id: 9,
                requirement:
                  "Regionalized Water-Budget Manual for Compensatory Wetland Mitigation Sites in New Jersey",
                attributeNexus: "Hydrologic Regime",
                metricAlignment: "Tidal Restriction Drainage",
                questionNeed:
                  "Does the proposed project have the appropriate features to maintain the in situ water budget?",
                info: "https://www.nj.gov/dep/landuse/download/mit_011.pdf",
                evaluated: false,
              },
              {
                id: 10,
                requirement:
                  "Proposed vegetative communities: species, quantity, spacing, stock type (plugs, potted, seed), source of plant material; include proper time to plant and appropriate substitutions",
                attributeNexus: "Hydrologic Regime",
                metricAlignment: "Vegetation Productivity Habitat",
                questionNeed:
                  "Quantified description of flora, fauna, and features to be installed in the proposed project.",
                info: "",
                evaluated: false,
              },
            ],
          },
          {
            id: 3,
            selected: false,
            type: "USACE",
            permit: "NP #13 Bank Stabilization",
            permitLink:
              "https://www.swt.usace.army.mil/Portals/41/docs/missions/regulatory/NationwidePermits/Nationwide Permit 13 - Bank Stabilization.pdf?ver=2017-03-31-150713-583",
            requirements: [
              {
                id: 1,
                requirement: "Activity is <= 500 feet in length along the bank ",
                attributeNexus: "Output Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "Overview Map",
                info: "ArcGIS, Google earth",
                evaluated: false,
              },
              {
                id: 2,
                requirement: "Fill <= AVERAGE 1 cubic yard / linear foot",
                attributeNexus: "Vertical Position",
                metricAlignment: "Elevation",
                questionNeed:
                  "How much cubic yard of fill is needed per linear foot, averaged?",
                info: "",
                evaluated: false,
              },
              {
                id: 3,
                requirement: "FEMA 100-year floodplain",
                attributeNexus: "Vertical Position",
                metricAlignment: "Drainage",
                questionNeed: "Will work here contribute to flooding elsewhere?",
                info: "https://msc.fema.gov/portal/home",
                evaluated: false,
              },
              {
                id: 4,
                requirement: "Native plants",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed:
                  "Ensure native plants are reintroduced, left undisturbed, or protected during installation.",
                info: "http://www.dnrec.delaware.gov/Admin/DelawareWetlands/Pages/DEWetlandPlantFieldGuide.aspx",
                evaluated: false,
              },
              {
                id: 5,
                requirement:
                  "Cannot occur in a component of the National Wild and Scenic River System",
                attributeNexus: "Output Reflection",
                metricAlignment: "Habitat",
                questionNeed: "Site location must not be within these rivers.",
                info: "http://www.rivers.gov/",
                evaluated: false,
              },
              {
                id: 6,
                requirement: "Federal Endangered Species Act",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed:
                  "Ensure current location is not currently occupied by federally endangered species",
                info: "https://www.nj.gov/dep/fgw/tandespp.htm",
                info2: "http://www.nmfs.noaa.gov/pr/species/esa/",
                evaluated: false,
              },
              {
                id: 7,
                requirement:
                  "U.S. Fish and Wildlife Service, Information for Project Planning and Conservation (IPaC)",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed: "",
                info: "https://ecos.fws.gov/ipac/",
                evaluated: false,
              },
            ],
          },
          {
            id: 4,
            selected: false,
            type: "USACE",
            permit:
              "NP #27 Aquatic Habitat Restoration, Enhancement, and Establishment Activities",
            permitLink: "https://saw-reg.usace.army.mil/NWP2017/2017NWP27.pdf",
            requirements: [
              {
                id: 1,
                requirement:
                  "The conversion of a stream or natural wetlands to another aquatic habitat type (e.g., the conversion of a stream to wetland or vice versa) or uplands is not authorized",
                attributeNexus: "Aquatic habitat follows an ecological reference",
                metricAlignment: "Elevation",
                questionNeed: "Will a stream or natural wetland change function?",
                info: "Elevation Models, Tidal Datums",
                evaluated: false,
              },
              {
                id: 2,
                requirement:
                  "The binding stream enhancement or restoration agreement or wetland enhancement, restoration, or establishment agreement",
                attributeNexus: "Biological Community, Output Reflection",
                metricAlignment: "Habitat",
                questionNeed:
                  "Communicate with the district engineer regarding any stream or wetland enhancement or restoration",
                info: "Project description, Project plans, Location map, NRC Stream Corridor Restoration, https://www.nrcs.usda.gov/wps/portal/nrcs/detailfull/national/ndcsmc/?cid=nrcs143_009158%20, USDA Technical Service Provider, https://www.nrcs.usda.gov/wps/portal/nrcs/main/national/programs/technical/tsp/",
                evaluated: false,
              },
              {
                id: 3,
                requirement: "Aquatic habitat follows an ecological reference",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed: "",
                info: "An ecological reference may be based on the characteristics of an intact aquatic habitat or riparian area of the same type that exists in the region. An ecological reference may be based on a conceptual model developed from regional ecological knowledge of the target aquatic habitat type or riparian area.",
                evaluated: false,
              },
            ],
          },
          {
            id: 5,
            selected: false,
            type: "USACE",
            permit: "NP #54 Living Shorelines",
            permitLink: "https://saw-reg.usace.army.mil/NWP2017/2017NWP54.pdf",
            requirements: [
              {
                id: 1,
                requirement:
                  "The structures and fill area, including sand fills, sills, breakwaters, or reefs, cannot extend into the waterbody more than 30 feet from the mean low water line in tidal waters",
                attributeNexus: "Horizontal Position",
                metricAlignment: "Elevation",
                questionNeed: "",
                info: "ArcGIS, Google earth, Tidal Datums",
              },
              {
                id: 2,
                requirement:
                  "The activity is no more than 500 feet in length along the bank",
                attributeNexus: "Horizontal Position",
                metricAlignment: "Lateral Shoreline Change",
                questionNeed: "",
                info: "ArcGIS, Google earth",
              },
              {
                id: 3,
                requirement:
                  "Coir logs, coir mats, stone, native oyster shell, native wood debris, and other structural materials must be adequately anchored, of sufficient weight, or installed in a manner that prevents relocation in most wave action or water flow conditions, except for extremely severe storms",
                attributeNexus: "Hydrologic Regime\nOutput Reflection",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "",
                info: "",
              },
              {
                id: 4,
                requirement:
                  "For living shorelines consisting of tidal or lacustrine fringe wetlands, native plants appropriate for current site conditions, including salinity, must be used if the site is planted by the permittee",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed: "",
                info: "http://www.dnrec.delaware.gov/Admin/DelawareWetlands/Pages/DEWetlandPlantFieldGuide.aspx",
              },
            ],
          },
          {
            id: 6,
            selected: false,
            type: "DNREC",
            permit: "Subaqueous Lands Permit",
            permitLink:
              "http://www.dnrec.delaware.gov/wr/Documents/WSLS/Basic Application Form.pdf",
            requirements: [
              {
                id: 1,
                requirement:
                  "Map: location and boundaries, adjoining property lines, nearest existing street or road intersection, specific location of all proposed activity",
                attributeNexus: "Horizontal Position",
                metricAlignment: "Regulatory Consideration 1",
                questionNeed: "",
                info: "Tax Parcels\nState streets and roads",
              },
              {
                id: 2,
                requirement: "Location of wetlands and aquatic habitats",
                attributeNexus: "Biological Community",
                metricAlignment: "Habitat",
                questionNeed: "",
                info: "Land use / land cover\nSoils Webmap: https://websoilsurvey.sc.egov.usda.gov/app/",
              },
              {
                id: 3,
                requirement:
                  "Efforts shall be made to utilize shoreline erosion control methods that best provide\nfor the conservation of aquatic nearshore habitat, maintain water quality, and\navoid other adverse environmental effects",
                attributeNexus: "",
                metricAlignment: "",
                questionNeed: "",
                info: "",
              },
              {
                id: 4,
                requirement:
                  ">> 4.10 Installation and Use of Shoreline Erosion Control Measures\nStructural erosion control measures shall address and satisfy the following\nelements:\n > Protection of aquatic biota, wetlands, and nearshore shallow water habitat\n> Protection of water quality, flushing, and naturally occurring littoral drift and\nflow.\n> Adequate flow and circulation necessary to support the functional value of\nadjacent wetlands or aquatic habitat\n> Materials and methods of construction shall be sufficient to withstand the\nstresses to which they will be subjected, from wind, waves, tides, currents,\nice, and debris",
                attributeNexus: "Biological\n\nHydrological\n\nOutput Reflection",
                metricAlignment: "Habitat\n\nHydrology",
                questionNeed: "",
                info: "",
              },
              {
                id: 5,
                requirement:
                  ">> 4.7 Environmental Considerations\n>  Any impairment of water quality, either temporary or permanent. which may\nreasonably be expected to cause violation of the State Surface Water Quality\nStandards\n>  Any effect on shellfishing, finfishing, or other recreational activities, and existing or\ndesignated water uses\n>  Any harm to aquatic or tidal vegetation, benthic organisms or other flora and fauna\nand their habitats\n>   Any loss of natural aquatic habitat\n>  Any impairment of air quality\n>  The extent to which the proposed project may adversely impact natural surface\nand groundwater hydrology and sediment transport functions",
                attributeNexus: "Biological\n\nHydrological",
                metricAlignment: "Habitat\n\nHydrology",
                questionNeed: "",
                info: "",
              },
            ],
          },
        ],
        complete: false,
      })
    setSediment({
        type: 'sediment',
        title: 'Sediment',
        // attributes: [
        //     { id: 1, attribute: 'vertical', metric: 'surface accumulation', method: 'MH, sediment grid/plate (above MHW', currentValue: '', currentUnits: '', currentJust: '', criteriaLow: '', criteriaHigh: "", criteriaUnits: '', criteriaType: '', criteriaJust: '', violation: '' },
        //     { id: 2, attribute: 'horizon', metric: 'shoreline accumulation', method: 'MH, sediment grid/plate (below MHW', currentValue: '', currentUnits: '', currentJust: '', criteriaLow: '', criteriaHigh: "", criteriaUnits: '', criteriaType: '', criteriaJust: '', violation: '' },
        //     { id: 3, attribute: 'hydro', metric: 'suspended sedi', method: 'TSS, SSC', currentValue: '', currentUnits: '', currentJust: '', criteriaLow: '', criteriaHigh: "", criteriaUnits: '', criteriaType: '', criteriaJust: '', violation: '' },
        //     { id: 4, attribute: 'bio', metric: 'decomp', methods: [{ id: 1, method: 'van post (qual)' }, { id: 2, method: 'decomp rate (qual)' }], method: '', currentValue: '', currentUnits: '', currentJust: '', criteriaLow: '', criteriaHigh: "", criteriaUnits: '', criteriaType: '', criteriaJust: '', violation: '' },
            
        // ],
        complete: false,
    })
    setSoil({
        type: 'soil',
        title: 'Soil Condition',
        // description: '',
        metrics: [
            {
                id: 1,
                metric: 'Sampled',
                methods: [
                    {id: 1, method: 'Auger'},
                    ]
            },
        ],
        metric: 'Sampled', 
        method: 'Auger',
        depth: '',
        organicMethod: '',
        parentType: '',
        parentMethod: '',
        parentDepth: '',
        decompLevel: '',
        decompDepth: '',
        decompMethod: '',
        forecastLow: '',
        forecastHigh:'',    
        currentConcern: -1,
        futureConcern: -1,
        soilSuggestion: 'need more information',
        complete: false,
        finalGrade: '',
        conversion: 0,
        organicGrade: '',
        parentGrade: '',
        decompGrade: '',
    })
    setVertical({
        type: 'vertical',
        title: 'Vertical Position',
        description: 'Describes features that relate or influence elevation-related position.',
        metrics: [{id: 1, metric: 'Marsh Platform Elevation', methods: [
            {id: 1, method: 'RTK-GPS Survey' },
            {id: 3, method: "Laser Level Height Relative to Position on Permanent Post or Other Structure"},
            {id: 4, method: 'LiDAR'},
            {id: 5, method: 'Surveying Instrument (Barcode Leveling)'},
        ]}],
        metric: 'Marsh Platform Elevation',
        method: '',
        currentValue: '',
        valueDesc: 'Negative values represent a loss (erosion, subsidence) of elevation',
        units: '',
        unitDesc: 'Relative to a vertical datum',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: '',
        
        criteriaType: '',
        criteriaJust: '',
        trajectLow: '',
        trajectHigh: '',
        
        trajectJust: '',
        forecastYears: '',
        forecastJust: '',
        forecastLow: '',
        forecastHigh:'',
        slrRate: '',
        
        currentConcern: -1,
        futureConcern: -1,
        attribConcern: false,
        complete: false,
    })
    setVertsed({
        type: 'vertsed',
        title: 'Vertical Sediment',
        attribute: 'vertical',
        metric: 'Surface Accumulation',
        method: 'MH, sediment grid/plate (above MHW)',
        currentValue: '',
        units: '',
        currentJust: '',
        criteriaLow: '',
        criteriaHigh: "",
        criteriaType: '',
        criteriaJust: '',
        currentConcern: -1,
        complete: false,
    })
    setWater({
        type: 'water',
        title: 'Water Chemistry',
        // description: '',
        metrics: [
            {id: 1, metric: 'pH'},
            {id: 2, metric: 'Conductivity'},
            {id: 3, metric: 'Salinity'},
            {id: 4, metric: 'Phytoplankton'},
            {id: 5, metric: 'pNitrogen or pNitrate'},
            {id: 6, metric: 'Dissolved Oxygen'},
        ],
        metric: 'salinity',
        currentValue: '',
        valueDesc: 'Negative values represent a loss (erosion, subsidence) of elevation',
        units: 'ppt',
        currentJust: '',
        salinityStatus: '',
        // oxygenStatus: '',
        forecastLow: '',
        forecastHigh:'',
        complete: false,
    })
    return
}

export default resetData